function initFeaturedMediaViewers() {
  document.querySelectorAll(".featured-media__viewer[data-video-id]").forEach(function (el, idx) {
    if (el.dataset.initialized === "true") return;

    var videoId = el.getAttribute("data-video-id");
    if (!videoId) return;

    var containerId = "feature-media-s7viewer-" + idx;
    el.id = containerId;
    el.dataset.initialized = "true";

    var viewer = new s7viewers.VideoViewer({
      containerId: containerId,
      params: {
        asset: videoId,
        config: "bhsf/Video",
        serverurl: "https://s7d9.scene7.com/is/image/",
        contenturl: "https://s7d9.scene7.com/is/content/",
        videoserverurl: "https://s7d9.scene7.com/is/content",
        loop: "1",
        volume: "0",
        mute: "1",
        controls: "none"
      },
      handlers: {
        initComplete: function () {
          var s7container = el.querySelector(".s7container");
          if (s7container) {
            s7container.removeAttribute("role");
          }

          var player = viewer.videoplayer;
          if (player) {
            var videoEl = el.querySelector('video');
            if (videoEl) {
              videoEl.muted = true;
              videoEl.setAttribute('muted', '');
            }

            player.mute();
          }
          
          var controls = el.querySelector(".s7controlbar");
          if (controls) {
            controls.style.display = "none";
          }

          const videoContainer = el.closest('.featured-media--video');
          const imageFade = videoContainer.querySelector('.featured-media__image');
          // Event listeners for mouse enter and leave
          videoContainer.addEventListener('mouseenter', () => {
            if (window.innerWidth > 599) {
              imageFade.style.opacity = 0; // Fade out the image
            }
            player.play(); // Play video on mouse enter
            player.mute();
          });

          videoContainer.addEventListener('mouseleave', () => {
            imageFade.style.opacity = 1; // Fade in the image
            player.pause(); // Pause video on mouse leave
          });
        }
      }
    });

    viewer.init();
    el.viewer = viewer;
  });
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".featured-media__viewer[data-video-id]")) {
    Scene7Loader.load(initFeaturedMediaViewers);
  }
});
